// usePickingScanXL - Sprint 44 Fase 3 Vista 7.
// Hook de pantalla de escaneo. Beep WebAudio (ok 880Hz, err 220Hz).
// flash auto-dismiss (ok 1.2s, err 2s). Tras completar genera packing y
// navega a /packing/:id si backend devuelve packing_id.
// Reusa pickingService legacy. Cero backend touch.
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as svc from '../../picking/services/pickingService';

function beep(freq, durationMs) {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = 'square';
    o.frequency.value = freq || 440;
    g.gain.value = 0.1;
    o.connect(g); g.connect(ctx.destination);
    o.start();
    setTimeout(() => {
      try { o.stop(); ctx.close(); } catch (_) { /* ignore */ }
    }, durationMs || 120);
  } catch (_) { /* webaudio no disponible */ }
}

export default function usePickingScanXL() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [picking, setPicking]   = useState(null);
  const [loaded, setLoaded]     = useState(false);
  const [scanning, setScanning] = useState(false);
  const [flash, setFlash]       = useState(null);
  const [completing, setCompleting] = useState(false);

  const refresh = useCallback(async () => {
    try { setPicking(await svc.getPicking(id)); }
    catch (_) {
      setFlash({ kind: 'err', text: 'No se pudo cargar' });
      setTimeout(() => setFlash(null), 2000);
    }
  }, [id]);

  useEffect(() => {
    let alive = true;
    (async () => {
      await refresh();
      if (alive) setLoaded(true);
    })();
    return () => { alive = false; };
  }, [refresh]);

  const onScan = useCallback(async (code) => {
    try {
      const r = await svc.scanPicking(id, code);
      beep(880, 80);
      const nombre = (r && r.linea && r.linea.producto_nombre) || code;
      setFlash({ kind: 'ok', text: '\u2713 ' + nombre });
      if (r && r.picking) setPicking(r.picking);
      setTimeout(() => setFlash(null), 1200);
    } catch (e) {
      beep(220, 300);
      setFlash({ kind: 'err', text: (e && e.message) || 'Error' });
      setTimeout(() => setFlash(null), 2000);
    }
  }, [id]);

  const onCompletar = useCallback(async () => {
    if (!window.confirm('Completar picking?')) return;
    setCompleting(true);
    try {
      const r = await svc.completarPicking(id);
      setFlash({ kind: 'ok', text: 'Picking completado' });
      await refresh();
      if (r && r.packing_id) {
        setTimeout(() => navigate('/packing/' + r.packing_id), 600);
      } else {
        setTimeout(() => setFlash(null), 1500);
      }
    } catch (e) {
      setFlash({ kind: 'err', text: (e && e.message) || 'Error al completar' });
      setTimeout(() => setFlash(null), 2000);
    } finally {
      setCompleting(false);
    }
  }, [id, navigate, refresh]);

  // ESC cierra modo escaneo
  useEffect(() => {
    if (!scanning) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setScanning(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [scanning]);

  return {
    id, navigate, picking, loaded,
    scanning, setScanning,
    flash, completing,
    onScan, onCompletar, refresh,
  };
}
